<template>
  <div class="container">
    <div class="box is-large mb-4">
      <h1 class="title is-4 mb-3">
        {{ $t('onboarding.end.title') }}
      </h1>
      <p>
        {{ $t('onboarding.end.description') }}
      </p>

      <div
        v-if="$registration.host.terms_url"
        class="mt-2"
      >
        <a
          :href="$registration.host.terms_url"
          target="_blank"
          download
          class="underline"
        >{{ $t('terms_and_conditions') }}</a>
      </div>

      <b-field class="mt-5">
        <b-checkbox v-model="accepted">
          {{ $t('agree_to_terms_and_conditions') }}
        </b-checkbox>
      </b-field>

      <button
        class="button is-primary mt-5"
        :class="{'is-loading': loading}"
        @click="end()"
      >
        <span>{{ $t("complete_registration") }}</span>
        <span class="icon">
          <i class="mdi mdi-arrow-right" />
        </span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      loading: false,
      accepted: false
    };
  },
  methods: {
    end () {
      if (this.loading) {
        return;
      }

      if (!this.accepted) {
        this.$notificator.open({
          message: this.$t("you_must_accept_terms_and_conditions"),
          type: "danger"
        });
        return;
      }

      this.loading = true;
      this.$http.post(Registration.completeUrl)
        .then(response => {
          window.location.replace(Registration.successUrl);
        })
        .finally(error => {
          this.loading = false;
        });
    }
  }
};
</script>
